import { assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Store the last known modifications and mixed dressing details to support
 * rollback on customization cancelation.
 */
export const storeLastKnownModifications: CustomizationMachineAction = assign((args) => {
  const { modifications, mixedDressingDetails } = args.context;

  return {
    lastKnownModifications: modifications ? { ...modifications } : undefined,
    lastKnownMixedDressingDetails: [...mixedDressingDetails],
  };
});
